<template>
  <div
    :class="[
      'border border-solid border-faint-grey rounded',
      'px-2 pb-2 pt-1',
      'flex flex-col'
    ]"
  >
    <template v-for="(child, pos) in value.children">
      <label v-if="debug" class="text-danger font-bold" :key="pos">{{ pos }} - {{ child.name }}</label>
      <template v-if="!child.component">
        <div
          v-if="shouldShow(child.name) && !isSubField(child)"
          :key="child.name"
          style="margin-left: -1.5rem; margin-right: -1.5rem;"
          :class="[
            'border-solid border-t-0 border-r-0 border-l-0 border-b border-faint-grey my-1 shadow-drop'
          ]"
        />
        <transition :key="child.name" name="fade">
          <formulate-field-adapter
            v-if="shouldShow(child.name)"
            @mounted="emitField"
            :disabled="disabled"
            :class="{
              'mb-2': !isSubField(value.children[pos+1]) && !isAttachmentItem(value.children[pos+1]),
              'mb-0': isAttachmentItem(value.children[pos+1]),
            }"
            :key="child.name"
            :field="child"
          />
        </transition>
      </template>
      <component
        v-else
        :key="child.name"
        :is="child.component"
        :class="[
          'pl-1',
          isAttachmentItem(value.children[pos+1]) ? 'mb-0' : 'mb-2'
        ]"
      >
        <div
          v-html-safe="child.children"
          @click.capture="onFormulaAttachmentLinkClick"
        />
      </component>
    </template>
  </div>
</template>

<script>
import FormulateFieldAdapter from './FormulateFieldAdapter.vue'

export default {
  components: { FormulateFieldAdapter },
  props: {
    value: {
      default: () => ({}),
      type: Object
    },
    showCriteria: {
      default: () => ({}),
      type: Object
    },
    debug: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /** v-html-safe remove onclick; links .formula-attachment-anchor rolam até #attachments sem mudar o hash da rota */
    onFormulaAttachmentLinkClick(e) {
      const el = e.target.nodeType === Node.TEXT_NODE ? e.target.parentElement : e.target
      const link = el && el.closest ? el.closest('a.formula-attachment-anchor') : null
      if (!link) return
      const targetId = link.getAttribute('data-scroll-target')
      if (!targetId) return
      e.preventDefault()
      e.stopPropagation()
      const targetEl = document.getElementById(targetId)
      if (targetEl) {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    emitField(fieldName, fieldVm) {
      this.$emit('mounted-field', fieldName, fieldVm)
    },
    shouldShow(id) {
      return this.showCriteria && this.showCriteria[id]
    },
    isSubField(field) {
      return (
        field &&
        'render_params' in field &&
        field.render_params &&
        'show_when' in field.render_params && this._.isString(field.render_params.show_when)
      )
    },
    /** Itens gerados pelo compiler como spans com [N] filename (anexos numerados) */
    isAttachmentItem(field) {
      return !!(field && field.component === 'span' && typeof field.children === 'string' && field.children.includes('formula-attachment-anchor'))
    }
  }
}
</script>

<style>

</style>
